import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import actionCreators from './remindPassFormActionCreators';

import RemindPassForm from './remindPassForm';

const mapStateToProps = (state) => ({ ...state.remindPassForm });

/**
 *
 * @deprecated
 * @see `cs/components/remindPassForm/new/NewRemindPassForm.tsx`
 */
const RemindPassFormContainer = (props) => <RemindPassForm {...props} />;

RemindPassFormContainer.propTypes = {
    email: PropTypes.string,
    isInvalidEmail: PropTypes.bool,
    isUnknownEmail: PropTypes.bool,
    isPassedSuccessful: PropTypes.bool,
    isLoading: PropTypes.bool,
    errorMessage: PropTypes.string,
    onChangeEmail: PropTypes.func.isRequired,
    onValidateEmail: PropTypes.func.isRequired,
    onSubmitForm: PropTypes.func.isRequired,
};

export default connect(
    mapStateToProps,
    actionCreators,
)(RemindPassFormContainer);
